import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { PaymentProviderQrDto } from '@model/MasterTransactionDto'

import { DepositProceedValues } from '../hooks/useDepositProceedRedirect'
import { ProceedModalContent } from './components/ProceedModalContent'

interface LocalInternetBankingModalProps {
  onProceed(): void
  values: DepositProceedValues
  providerName: string
  qr?: PaymentProviderQrDto | null
  transactionId?: string
  onQrSuccess?(): void
  onQrDeclined?(): void
}

export const LocalInternetBankingProceedModal: BaseModalType<LocalInternetBankingModalProps> = ({
  onProceed,
  values,
  providerName,
  qr,
  transactionId,
  onQrSuccess,
  onQrDeclined,
  close,
}) => {
  const { t } = useTranslation()

  if (!values) return null

  return (
    <ProceedModalContent
      values={values}
      qr={qr}
      transactionId={transactionId}
      onProceed={onProceed}
      close={close}
      onQrSuccess={onQrSuccess}
      onQrDeclined={onQrDeclined}
    >
      <Modal.Body.Text>
        {t('You will be redirected to an external payment provider to complete your transaction')}
      </Modal.Body.Text>
      <Modal.Body.Text>
        {t('Transfers via the local option are only available in local currency', {
          provider: providerName,
        })}
      </Modal.Body.Text>
    </ProceedModalContent>
  )
}
